import { render, staticRenderFns } from "./FloatingRobot.vue?vue&type=template&id=020308e4&scoped=true&"
import script from "./FloatingRobot.vue?vue&type=script&lang=js&"
export * from "./FloatingRobot.vue?vue&type=script&lang=js&"
import style0 from "./FloatingRobot.vue?vue&type=style&index=0&id=020308e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020308e4",
  null
  
)

export default component.exports